/** Сценарии и этапы работы с баннерами Adfox */
export enum EAdfoxAnalyticsPayloadType {
  /** Данные до обогащения из Adfox, события до load */
  WithoutAdfoxData = 'withoutAdfoxData',
  /** Данные после успешного обогащения из Adfox, события от load и далее */
  WithAdfoxData = 'withAdfoxData',
  /** Данные после неуспешного обогащения из Adfox, события от error и далее */
  WithAdfoxErrorData = 'withAdfoxErrorData',
  /** Данные после успешного обогащения из Adfox, но с внутренней ошибкой библиотеки */
  ErrorWithAdfoxData = 'errorWithAdfoxData',
}
